import { backofficeRequest } from '../../../axios'

export const getBankingHistoryIntranet = async (coproId) => {
  try {
    const res = await backofficeRequest.get(
      `backoffice/condos/${coproId}/bank-accounts/`
    )
    return res.data
  } catch (error) {
    console.log('Error ApiBankingHistory:', error)
    return []
  }
}
